// extracted by mini-css-extract-plugin
export var addinsPane = "Ku2Br";
export var brandIcon = "c40th";
export var buttonIcon = "kKPll";
export var copilotPanelContainer = "JC755";
export var customFlexPane = "rCGyX";
export var devSourceLabel = "ZU_q2";
export var fullHeightFlexPane = "dzinj";
export var groupsPanelContainer = "XNhWf";
export var timePanelContainer = "run_N";